import { render, staticRenderFns } from "./home_footer.vue?vue&type=template&id=c4936a8a&scoped=true&"
import script from "./home_footer.vue?vue&type=script&lang=js&"
export * from "./home_footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4936a8a",
  null
  
)

export default component.exports